'use strict';

/**
 * @module views/markers/place
 * @author Sebastian Pekarek
 */

const MARKER_SIZE = 10;
const MARKER_SPACE = 2;
const MARKER_SELECTED_BORDER_WIDTH = 3;

const Marker = require('./_');
const ConfigurationHelper = require('../../helpers/configuration');
const EventHelper = require('../../helpers/event');

class PlaceMarker extends Marker {
	constructor (place, map) {
		super({
			type: 'place',
			object: place,
			map
		});

		google.maps.event.addListener(this.marker, 'click', () => {
			if (ConfigurationHelper.openMarkerDirectly() === true) {
				window.open(ConfigurationHelper.getBookingUrl({place: place}), 'ewi3');
				return;
			}
			
			if (this.selected()) {
				EventHelper.unselectPlace();
			} else {
				EventHelper.selectPlace({
					placeId: place.id,
					options: {
						single: true,
						panTo: true
					}
				});
			}
		});
		
		EventHelper.onPlaceSelect(this, this.handlePlaceSelect);
	}
	
	handlePlaceSelect (data) {
		if (data.places.includes(this.object.id)) {
			this.selected(true, data.options.panTo);
		} else {
			this.selected(false);
		}
	}

	renderMarker () {
		const icon = {};
		if (ConfigurationHelper.getCustomMarkerConfig('place')) {
			const customMarkerConf = ConfigurationHelper.getCustomMarkerConfig('place');
			icon.size = new google.maps.Size(customMarkerConf.size[0], customMarkerConf.size[1]);
			icon.scaledSize = new google.maps.Size(customMarkerConf.scaledSize[0], customMarkerConf.scaledSize[1]);
			icon.anchor = new google.maps.Point(customMarkerConf.anchor[0], customMarkerConf.anchor[1]);
			icon.url = PlaceMarker.getPlaceMarkerUrl(!!this.object.selected);
		} else {
			icon.anchor = new google.maps.Point(MARKER_SIZE * MARKER_SPACE, MARKER_SIZE * MARKER_SPACE),
			icon.origin = new google.maps.Point((MARKER_SIZE * MARKER_SPACE * 2 - MARKER_SIZE * MARKER_SPACE) / -2, (MARKER_SIZE * MARKER_SPACE * 2 - MARKER_SIZE * MARKER_SPACE) / -2), // -10
			icon.size = new google.maps.Size(MARKER_SIZE * MARKER_SPACE * 2, MARKER_SIZE * MARKER_SPACE * 2),
			icon.scaledSize = new google.maps.Size(MARKER_SIZE * MARKER_SPACE, MARKER_SIZE * MARKER_SPACE),
			icon.url = PlaceMarker.getPlaceMarkerUrl(!!this.object.selected)
		}

		return new google.maps.Marker({
			clickable: true,
			zIndex: 10,
			cursor: 'pointer',
			icon,
			map: this.map.map,
			optimized: false,
			infoWindow: null,
			position: new google.maps.LatLng(this.object.lat, this.object.lng),
			title: this.object.name
		});
	}

	selected (value, panToPlace) {
		if (value === undefined) {
			return this._selected || false;
		}

		this._selected = !!value;
		this.marker.setIcon(Object.assign({}, this.marker.getIcon(), {
			url: PlaceMarker.getPlaceMarkerUrl(this.selected())
		}));

		if(panToPlace && this._selected) {
			this.map.panTo(this.marker.getPosition(), 15);
		}
	}

	static getPlaceMarkerUrl (selected) {
		if (selected && ConfigurationHelper.getCustomMarkerConfig('place-selected')) {
			return ConfigurationHelper.getCustomMarkerConfig('place-selected').file;
		}
		if (ConfigurationHelper.getCustomMarkerConfig('place')) {
			return ConfigurationHelper.getCustomMarkerConfig('place').file;
		}
		if (PlaceMarker.markerCache && PlaceMarker.markerCache[selected]) {
			return PlaceMarker.markerCache[selected];
		}

		const canvas = document.createElement('canvas');
		canvas.width = MARKER_SIZE * MARKER_SPACE * 3;
		canvas.height = MARKER_SIZE * MARKER_SPACE * 3;

		const radius = MARKER_SIZE * 3 / 2;
		const context = canvas.getContext('2d');
		context.clearRect(0, 0, canvas.width, canvas.height);
		
		const selection = canvas.getContext('2d');
		selection.clearRect(0, 0, canvas.width, canvas.height);

		if (!selected) {
			const selection = canvas.getContext('2d');
			selection.clearRect(0, 0, canvas.width, canvas.height);
			selection.lineWidth = MARKER_SELECTED_BORDER_WIDTH * 2;
			selection.strokeStyle = ConfigurationHelper.getMarkerColor();
			selection.arc(canvas.width / 2, canvas.height / 2, radius * 1.2, 0, 2 * Math.PI);
			selection.stroke();
			
			context.fillStyle = ConfigurationHelper.getMarkerColor();
			context.beginPath();
			context.arc(canvas.width / 2, canvas.height / 2, radius * .5, 0, 2 * Math.PI);
			context.closePath();
			context.fill();
		}
		else {
			context.lineWidth = MARKER_SELECTED_BORDER_WIDTH * 5.5;
			context.strokeStyle = ConfigurationHelper.getMarkerColor();
			context.arc(canvas.width / 2, canvas.height / 2, radius * .95, 0, 2 * Math.PI);
			context.stroke();
		}

		const url = canvas.toDataURL('image/png');
		PlaceMarker.markerCache = PlaceMarker.markerCache || {};
		PlaceMarker.markerCache[selected] = url;
		return url;
	}
}

module.exports = PlaceMarker;
